import styles from './Fits.module.css';
import FitsImg from '../../Images/FitsImg.jpg';
import FitsBasics from '../../Images/FitsBasics.jpg';
import ClearanceFits from '../../Images/ClearanceFitsImg.jpg';
import TransitionFits from '../../Images/TransitionFitsImg.jpg';
import InterferenceFits from '../../Images/InterferenceFitsImg.jpg';

export default function Fits(props) {
    return (
        <div className={styles.fitsContainer}>
            {/* <SectionTitle title={props.topicId}/> */}
            <h1>Types of Fits</h1>
            <p>
                <h2>Overview of Engineering Fits;</h2>
                An engineering fit is the general term when describing two mechanical parts being joined together. The spectrum of fits exist between when a part is oversized and cannot fit without sufficient force and when a mating part is undersized and has ample room to slide and rotate.
                Essentially, the fit describes the clearance between two mating parts. There are three main types of fits, clearance, transition and interference.
                <br /><br />
                The two most common standards for engineering fits are ISO 286 and ANSI B4.1. The tolerance limits after being selected are then relayed to the manufacturing house via engineering drawings and GD&T symbols.
                <br /><br />
                <div className={styles.fitsImgWrapper}>
                    <img src={FitsImg} alt="FitsOverview" className={styles.fitsImg} />
                </div>
                <br />
                <h2>Hole and Shaft System;</h2>
                The hole and shaft systems are two systems in which either the shaft or the hole is being referenced as the “base” value and then having the other mating part referenced in relation to the base part.
                In both cases, the “base” part is referenced as having a fixed value for its dimensions while the other is sized to achieve the fit. For example, in the shaft basis system,
                your shaft diameter is fixed and you adjust the diameter of the hole based on the size of the shaft. The hole basis system is much more widely used than the shaft basis system. However, in the case where a shaft diameter cannot be controlled, then the shaft basis system should be used.
                <br /><br />
                <div className={styles.fitsImgWrapper}>
                    <img src={FitsBasics} alt="FitsBasics" className={styles.fitsImg} />
                </div>

                <h2>Clearance Fit;</h2>
                A clearance fit is a tolerance designed so that the largest shaft is smaller than the smallest hole leading to a slight gap between the mating surfaces. This allowance is always positive and greater than zero.
                This allows for a certain amount of “play” between the two surfaces, though it is often unobservable to the naked eye. The common range of clearance between these two surfaces is between +0.025mm to +0.089mm.
                <div className={styles.fitsImgWrapper}>
                    <img src={ClearanceFits} alt="ClearanceFits" className={styles.fitsImg} />
                </div>
                <br /><br />

                <h3>Clearance Fit: Loose Running;</h3>
                A loose running fit is set to the higher end of the tolerance allowance and has enough space for the parts to freely slide and rotate. This space allowance is typically observable to the naked eye.
                <br /><br />

                <h3>Clearance Fit: Free Running;</h3>
                A free running clearance fit has even more play than a loose running fit and is typically used when thermal expansion is an issue. The location accuracy is low due to the considerable play.
                <br /><br />

                <h3>Clearance Fit: Close Running;</h3>
                A close running fit has slightly tighter dimensional accuracy than the loose running fit and can accommodate higher speeds.
                <br /><br />

                <h3>Clearance Fit: Location;</h3>
                A location fit has even less tolerance than the sliding or close running fit and requires lubrication for smooth rotation.
                <br /><br />

                <h2>Transition Fit;</h2>
                A transition fit is the middle ground between the two clearance types and can have either a negative or positive clearance. When there is a negative clearance, the pressure and load carrying capacity is limited. When there is a positive clearance, there is more play and less accuracy.
                These types of fits are useful for precision locating parts in assemblies where you need a mix of mechanical stress prevention and movement restriction. The interference/clearance tolerance range for this type of fit is typically within +0.023mm to -0.018mm.
                <div className={styles.fitsImgWrapper}>
                    <img src={TransitionFits} alt="TransitionFits" className={styles.fitsImg} />
                </div>

                <h3>Transition Fit: Similar Fit;</h3>
                A similar fit will have a near zero clearance/interference between the two mating surfaces. Generally, a human action such as striking the part with a mallet is enough to achieve the fit.
                <br /><br />

                <h3>Transition Fit: Fixed Fit;</h3>
                A fixed fit will have an even smaller tolerance than the similar fit and will typically require a press to push and fit the parts together.
                <br /><br />

                <h2>Interference Fit;</h2>
                An interference fit is when the maximum clearance is negative and the parts must always be forced together. The mating parts are deformed in the joining process. This type of fit results in very high frictional forces preventing sliding and rotation in the mating parts.
                Although this fit is commonly achieved by use of a hydraulic press, it is also common for shrink fitting to be used. The clearance between these surfaces is typically -0.001mm to -0.042mm.
                <br /><br />
                <div className={styles.fitsImgWrapper}>
                    <img src={InterferenceFits} alt="InterferenceFits" className={styles.fitsImg} />
                </div>

                <h3>Interference Fit: Press Fit;</h3>
                For medium-strength joints, the press fits are on the lower end of the negative clearance spectrum.
                <br /><br />

                <h3>Interference Fit: Driving Fit;</h3>
                A driving fit will have an even greater negative tolerance than the press fit and requires either cold/hot pressing or machine enabled pressed forces to assemble.
                <br /><br />

                <h3>Interference Fit: Force Fit;</h3>
                Also known as shrink fits, this type of fit typically involves forcing a cooling or heating of a part, assembling it and then having the material expansion act as a force to keep parts together. The fits are nearly permanent and require careful tolerancing to avoid breaking the parts.
                <br /><br />
                The smallest force fit interference for a force fit is <br />
                Min Interference + LMC Shaft - LMC Hole
                <br /><br />
                The greatest amount of interference for a force fit is <br />
                Max Interference = MMC Shaft - MMC Hole
            </p>
        </div>
    )
}
